(function () {
  var toggle = document.querySelector('[data-rebx-tradein-toggle]');
  if (!toggle) return;

  var storageKey = 'rebx-show-tradein-prices';
  var rates = {
    credit: (parseFloat(toggle.dataset.creditRate) || 60) / 100,
    cash: (parseFloat(toggle.dataset.cashRate) || 55) / 100,
    creditStock: (parseFloat(toggle.dataset.creditRateStock) || 40) / 100,
    cashStock: (parseFloat(toggle.dataset.cashRateStock) || 35) / 100,
    threshold: parseInt(toggle.dataset.stockThreshold, 10) || 3
  };
  var counts = null;
  var countsPromise = null;

  function titleKey(title) {
    return String(title || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function tradeTokens(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\+/g, ' plus ')
      .replace(/(\d+(?:\.\d+)?)\s*(gb|tb)\b/g, '$1$2')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
  }

  function loadTradePrices(url) {
    if (window.RebxTradeInPriceRows) return Promise.resolve(window.RebxTradeInPriceRows);
    if (window.RebxTradeInPriceRowsPromise) return window.RebxTradeInPriceRowsPromise;
    if (!url) return Promise.resolve([]);
    window.RebxTradeInPriceRowsPromise = fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('prices');
        return res.json();
      })
      .then(function (rows) {
        var prepared = (rows || []).map(function (row) {
          return {
            name: row.name,
            cash: Math.round(Number(row.cash)),
            tokens: tradeTokens(row.name)
          };
        }).filter(function (row) {
          return row.tokens.length && row.cash > 0;
        });
        prepared.sort(function (a, b) {
          return b.tokens.length - a.tokens.length || b.name.length - a.name.length;
        });
        window.RebxTradeInPriceRows = prepared;
        return prepared;
      })
      .catch(function () {
        window.RebxTradeInPriceRows = [];
        return [];
      });
    return window.RebxTradeInPriceRowsPromise;
  }

  function matchTradePrice(title) {
    var rows = window.RebxTradeInPriceRows;
    if (!rows || !rows.length || !title) return null;
    var have = {};
    tradeTokens(title).forEach(function (token) { have[token] = true; });
    for (var i = 0; i < rows.length; i++) {
      var tokens = rows[i].tokens;
      var ok = true;
      for (var j = 0; j < tokens.length; j++) {
        if (!have[tokens[j]]) {
          ok = false;
          break;
        }
      }
      if (ok) return rows[i];
    }
    return null;
  }

  function formatPounds(amount) {
    return '£' + Math.round(amount).toLocaleString('en-GB');
  }

  function quote(cents, qty, title) {
    var listed = matchTradePrice(title);
    if (listed) {
      return {
        credit: Math.round(listed.cash * 60 / 55),
        cash: listed.cash
      };
    }
    var pounds = cents / 100;
    var plenty = qty >= rates.threshold;
    return {
      credit: Math.round(pounds * (plenty ? rates.creditStock : rates.credit)),
      cash: Math.round(pounds * (plenty ? rates.cashStock : rates.cash))
    };
  }

  function cards() {
    return document.querySelectorAll('[data-tradein-card]');
  }

  function countVisible() {
    var next = {};
    cards().forEach(function (card) {
      var key = titleKey(card.getAttribute('data-title'));
      if (!key) return;
      next[key] = (next[key] || 0) + 1;
    });
    return next;
  }

  function collectionUrl() {
    var input = document.getElementById('RebxCollectionSearch');
    if (!input) return '';
    return input.dataset.collectionUrl || '';
  }

  function loadCounts() {
    if (counts) return Promise.resolve(counts);
    if (countsPromise) return countsPromise;
    var url = collectionUrl();
    if (!url) {
      counts = countVisible();
      return Promise.resolve(counts);
    }
    countsPromise = (async function () {
      var next = {};
      for (var page = 1; page <= 8; page += 1) {
        var response = await fetch(url + '/products.json?limit=250&page=' + page);
        if (!response.ok) break;
        var data = await response.json();
        var products = data.products || [];
        products.forEach(function (product) {
          var qty = 0;
          (product.variants || []).forEach(function (variant) {
            if (variant.available) qty += 1;
          });
          if (!qty) return;
          var key = titleKey(product.title);
          next[key] = (next[key] || 0) + qty;
        });
        if (products.length < 250) break;
      }
      counts = Object.keys(next).length ? next : countVisible();
      return counts;
    })().catch(function () {
      counts = countVisible();
      return counts;
    });
    return countsPromise;
  }

  var grid = document.getElementById('ProductGridContainer');
  var observer = null;
  if (grid && window.MutationObserver) {
    var timer = 0;
    observer = new MutationObserver(function () {
      if (!document.documentElement.classList.contains('rebx-show-tradein-prices')) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(refresh, 50);
    });
    observer.observe(grid, { childList: true, subtree: true });
  }

  function paint(stock) {
    if (observer) observer.disconnect();
    cards().forEach(function (card) {
      var cents = parseInt(card.getAttribute('data-price-cents'), 10);
      if (!(cents > 0)) return;
      var title = card.getAttribute('data-title');
      var key = titleKey(title);
      var qty = stock[key] || 1;
      var offer = quote(cents, qty, title);
      var credit = card.querySelector('[data-tradein-credit]');
      var cash = card.querySelector('[data-tradein-cash]');
      if (credit) credit.textContent = formatPounds(offer.credit);
      if (cash) cash.textContent = formatPounds(offer.cash);
      var wrap = card.closest('.card-wrapper');
      var link = wrap && wrap.querySelector('[data-tradein-cta]');
      if (link) {
        var href = link.getAttribute('href') || '';
        var base = href.split('?')[0];
        var params = new URLSearchParams(href.split('?')[1] || '');
        params.set('stock', String(qty));
        link.setAttribute('href', base + '?' + params.toString());
      }
    });
    if (observer && grid) observer.observe(grid, { childList: true, subtree: true });
  }

  function refresh() {
    paint(counts || countVisible());
    Promise.all([
      loadCounts(),
      loadTradePrices(toggle.getAttribute('data-price-list'))
    ]).then(function (results) {
      if (document.documentElement.classList.contains('rebx-show-tradein-prices')) paint(results[0]);
    });
  }

  function setOn(on) {
    document.documentElement.classList.toggle('rebx-show-tradein-prices', on);
    toggle.checked = on;
    try {
      sessionStorage.setItem(storageKey, on ? '1' : '0');
    } catch (err) {}
    if (on) refresh();
  }

  toggle.addEventListener('change', function () {
    setOn(toggle.checked);
  });

  var stored = false;
  try {
    stored = sessionStorage.getItem(storageKey) === '1';
  } catch (err) {}
  if (stored || document.documentElement.classList.contains('rebx-show-tradein-prices')) {
    setOn(true);
  }

  window.RebxTradeInPrices = { refresh: refresh };

  var drawerPromise = null;

  function loadAsset(tagName, src, attr) {
    return new Promise(function (resolve) {
      var existing = document.querySelector(tagName + '[' + attr + '="' + src + '"]');
      if (existing) {
        resolve();
        return;
      }
      var el = document.createElement(tagName);
      if (tagName === 'link') {
        el.rel = 'stylesheet';
        el.href = src;
      } else {
        el.src = src;
      }
      el.onload = function () { resolve(); };
      el.onerror = function () { resolve(); };
      document.head.appendChild(el);
    });
  }

  function ensureDrawer() {
    if (document.querySelector('#RebxTradeInDrawer [data-tradein-form]')) return Promise.resolve();
    if (drawerPromise) return drawerPromise;
    var host = document.getElementById('RebxTradeInDrawer');
    if (!host) return Promise.reject(new Error('missing drawer'));
    drawerPromise = fetch('/pages/trade-in')
      .then(function (res) {
        if (!res.ok) throw new Error('page');
        return res.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var section = parsed.querySelector('[id$="__trade_in_form"]');
        if (!section) throw new Error('section');
        var styles = Array.prototype.map.call(section.querySelectorAll('link[rel="stylesheet"]'), function (link) {
          return link.href;
        });
        var script = section.querySelector('script[src*="rebx-trade-in-form"]');
        var scriptSrc = script ? script.src : '';
        section.querySelectorAll('link[rel="stylesheet"], script[src]').forEach(function (node) {
          node.remove();
        });
        host.innerHTML = section.innerHTML;
        var modal = host.querySelector('[data-tradein-modal]');
        if (modal) modal.classList.add('rebx-tradein-modal--left');
        return Promise.all(styles.map(function (href) { return loadAsset('link', href, 'href'); }))
          .then(function () {
            if (!scriptSrc) return null;
            return loadAsset('script', scriptSrc, 'src');
          });
      })
      .catch(function (err) {
        drawerPromise = null;
        throw err;
      });
    return drawerPromise;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-tradein-cta]');
    if (!link) return;
    event.preventDefault();
    var href = link.getAttribute('href') || link.href;
    var params = new URLSearchParams((href.split('?')[1] || ''));
    var handle = (params.get('item') || '').trim();
    var stock = parseInt(params.get('stock'), 10);
    if (!handle) {
      window.location.href = href;
      return;
    }
    var label = link.textContent;
    link.setAttribute('aria-busy', 'true');
    link.textContent = 'Opening…';
    ensureDrawer()
      .then(function () {
        return fetch('/products/' + encodeURIComponent(handle) + '.js');
      })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (product) {
        var form = document.querySelector('#RebxTradeInDrawer [data-tradein-form]');
        if (!product || !form || !form.__rebxTradeIn) {
          window.location.href = href;
          return;
        }
        form.__rebxTradeIn.openFromListing(product, stock);
      })
      .catch(function () {
        window.location.href = href;
      })
      .then(function () {
        link.textContent = label;
        link.removeAttribute('aria-busy');
      });
  });
})();
